import ProfileHeader from "@/components/features/user-profile/profile-header";
import { VoucherDetailsForm } from "@/components/forms/voucher-details-form";
import { Separator } from "@/components/ui/separator";
import type { ProfileViewModel } from "@/lib/types";
import { useOutletContext } from "react-router";

const VouchAboutYou = () => {
  const profile = useOutletContext<ProfileViewModel>();

  return (
    <section className="animate-screen relative z-10 mx-auto flex max-w-4xl  flex-1 flex-col  gap-5  px-6 py-24 sm:gap-10">
      <ProfileHeader profile={profile} label={"Last step"} />
      <Separator />

      <div className="flex flex-col items-start gap-5">
        {/* <VouchFormHeader title="A few details about you" /> */}
        <VoucherDetailsForm voucheeName={profile?.FirstName} />
      </div>
    </section>
  );
};

export default VouchAboutYou;
